// extracted by mini-css-extract-plugin
export var footerContainer = "M_ct";
export var footerContent = "M_cw";
export var footerDisclosure = "M_cx";
export var menu = "M_cv";